import { render, staticRenderFns } from "./SundryCreditorPayments.vue?vue&type=template&id=32a1090e&scoped=true"
import script from "./SundryCreditorPayments.vue?vue&type=script&lang=js"
export * from "./SundryCreditorPayments.vue?vue&type=script&lang=js"
import style0 from "./SundryCreditorPayments.vue?vue&type=style&index=0&id=32a1090e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a1090e",
  null
  
)

export default component.exports